export var stringToDate = function stringToDate(str) {
  var match = /(\d+)\/(\d+)\/(\d+)/.exec(str) || [];
  var date = new Date(match[3], match[2] - 1, match[1]);
  return !Number.isNaN(date.getTime()) ? date : null;
};
export var dateToString = function dateToString(date) {
  if (date && !Number.isNaN(date.getTime())) {
    var day = date.getDate() < 10 ? "0".concat(date.getDate()) : date.getDate().toString();
    var month = date.getMonth() + 1 < 10 ? "0".concat(date.getMonth() + 1) : (date.getMonth() + 1).toString();
    return "".concat(day, "/").concat(month, "/").concat(date.getFullYear());
  }

  return null;
};